function hideEmptyBundles() {
	const checkTime = performance.now()
	document.querySelectorAll('ec-complementary-bundle').forEach((bundle) => {
		const recommendationsElement = bundle.querySelector('product-recommendations')
		if (!recommendationsElement) {
			bundle.style.opacity = '0'
			const section = bundle.closest('.page-width')
			if (section) {
				section.style.opacity = '0'
			}
			setTimeout(() => {
				bundle.style.display = 'none'
				if (section) {
					section.style.display = 'none'
				}
			}, 300)
			return
		}

		const items = recommendationsElement.querySelectorAll('.ec-bundle-item')
		const itemsCount = items.length
		const isLoaded = recommendationsElement.classList.contains('product-recommendations--loaded')
		const hasContent = recommendationsElement.innerHTML.trim().length > 0
		if (itemsCount > 0) {
			if (bundle.startTime && !bundle.firstRenderTime) {
				const elapsed = bundle.startTime ? ((checkTime - bundle.startTime) / 1000).toFixed(2) : 'N/A'
				bundle.firstRenderTime = elapsed
				bundle.renderTimes = bundle.renderTimes || []
				bundle.renderTimes.push(parseFloat(elapsed))
			}
			bundle.style.display = ''
			bundle.style.opacity = '1'
			const section = bundle.closest('.page-width')
			if (section) {
				section.style.display = ''
				section.style.opacity = '1'
			}
		} else if (itemsCount === 0) {
			const hasGridItems = recommendationsElement.querySelectorAll('.grid__item').length > 0
			const dataUrl = recommendationsElement.dataset.url
			const hasInitialContent = recommendationsElement.querySelector('.ec-bundle-item') !== null
			const elapsedMs = bundle.startTime ? (checkTime - bundle.startTime) : 0
			const timeoutLimit = bundle.timeoutLimit || 1000
			
			if (bundle.startTime && elapsedMs >= timeoutLimit && !bundle.hasTimedOut) {
				bundle.hasTimedOut = true
				bundle.style.opacity = '0'
				const section = bundle.closest('.page-width')
				if (section) {
					section.style.opacity = '0'
				}
				setTimeout(() => {
					bundle.style.display = 'none'
					if (section) {
						section.style.display = 'none'
					}
				}, 300)
			} else if (isLoaded && !hasGridItems) {
				bundle.style.opacity = '0'
				const section = bundle.closest('.page-width')
				if (section) {
					section.style.opacity = '0'
				}
				setTimeout(() => {
					bundle.style.display = 'none'
					if (section) {
						section.style.display = 'none'
					}
				}, 300)
			} else if (hasContent && !hasGridItems && !hasInitialContent) {
				bundle.style.opacity = '0'
				const section = bundle.closest('.page-width')
				if (section) {
					section.style.opacity = '0'
				}
				setTimeout(() => {
					bundle.style.display = 'none'
					if (section) {
						section.style.display = 'none'
					}
				}, 300)
			} else if (!hasContent && !hasInitialContent && !dataUrl) {
				bundle.style.opacity = '0'
				const section = bundle.closest('.page-width')
				if (section) {
					section.style.opacity = '0'
				}
				setTimeout(() => {
					bundle.style.display = 'none'
					if (section) {
						section.style.display = 'none'
					}
				}, 300)
			}
		}
	})
}

function checkAndHideEmptyBundles() {
	setTimeout(() => {
		hideEmptyBundles()
	}, 2000)
	
	setTimeout(() => {
		hideEmptyBundles()
	}, 5000)

	setTimeout(() => {
		hideEmptyBundles()
	}, 8000)

	setTimeout(() => {
		const checkTime = performance.now()
		document.querySelectorAll('ec-complementary-bundle').forEach((bundle) => {
			const recommendationsElement = bundle.querySelector('product-recommendations')
			if (!recommendationsElement) return

			const items = recommendationsElement.querySelectorAll('.ec-bundle-item')
			const itemsCount = items.length
			const isLoaded = recommendationsElement.classList.contains('product-recommendations--loaded')
			const hasContent = recommendationsElement.innerHTML.trim().length > 0
			const hasInitialContent = recommendationsElement.querySelector('.ec-bundle-item') !== null
			const dataUrl = recommendationsElement.dataset.url
			const elapsed = bundle.startTime ? ((checkTime - bundle.startTime) / 1000).toFixed(2) : 'N/A'

			if (itemsCount === 0 && (!dataUrl || (!hasContent && !hasInitialContent))) {
				bundle.style.opacity = '0'
				const section = bundle.closest('.page-width')
				if (section) {
					section.style.opacity = '0'
				}
				setTimeout(() => {
					bundle.style.display = 'none'
					if (section) {
						section.style.display = 'none'
					}
				}, 300)
			} else if (itemsCount === 0 && isLoaded) {
				bundle.style.opacity = '0'
				const section = bundle.closest('.page-width')
				if (section) {
					section.style.opacity = '0'
				}
				setTimeout(() => {
					bundle.style.display = 'none'
					if (section) {
						section.style.display = 'none'
					}
				}, 300)
			} else if (bundle.firstRenderTime) {
				bundle.style.opacity = '1'
				const section = bundle.closest('.page-width')
				if (section) {
					section.style.opacity = '1'
				}
			}
		})
	}, 10000)
}

document.addEventListener('shopify:section:load', () => {
	setTimeout(() => {
		checkAndHideEmptyBundles()
	}, 1000)
})

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => {
		checkAndHideEmptyBundles()
	})
} else {
	checkAndHideEmptyBundles()
}

if (!customElements.get('ec-complementary-bundle')) {
	class EcComplementaryBundle extends HTMLElement {
		constructor() {
			super()
			this.bundleContainer = this
			this.button = null
			this.mainVariantId = null
			this.selectedProducts = new Map()
			this.cart = null
			this.sectionId = null
			this.startTime = performance.now()
			this.firstRenderTime = null
			this.renderTimes = []
			this.timeoutLimit = 1000
			this.hasTimedOut = false
			this.mainProductPrice = 0
			this.checkboxes = []
			this.variantSelects = []
		}

		connectedCallback() {
			this.button = this.querySelector('.ec-bundle-button')
			this.mainVariantId = this.button?.dataset.mainVariantId
			this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer')
			this.sectionId = this.dataset.sectionId

			const mainPriceElement = this.querySelector('[data-main-product-price]')
			if (mainPriceElement) {
				const priceValue =
					mainPriceElement.dataset.mainProductPrice ||
					mainPriceElement.getAttribute('data-main-product-price')
				this.mainProductPrice = priceValue ? parseInt(priceValue) : 0
			} else {
				const totalElement = this.querySelector('#BundleTotal-' + this.sectionId)
				if (totalElement) {
					const initialPrice = totalElement.getAttribute('data-total-price')
					this.mainProductPrice = initialPrice ? parseInt(initialPrice) : 0
				} else {
					this.mainProductPrice = 0
				}
			}

			this.init()
		}

		init() {
			this.initializeCheckboxes()
			
			this.variantSelects = this.querySelectorAll('.ec-bundle-variant-select')
			this.variantSelects.forEach((select) => {
				if (!select.hasAttribute('data-listener-added')) {
					select.setAttribute('data-listener-added', 'true')
					select.addEventListener('change', this.handleVariantChange.bind(this))
				}
			})

			if (this.button && !this.button.hasAttribute('data-listener-added')) {
				this.button.setAttribute('data-listener-added', 'true')
				this.button.addEventListener('click', this.handleAddToCart.bind(this))
			}

			this.updateRecommendations()
			
			if (this.sectionId) {
				this.updateSummary()
				this.updateTotal()
			}
		}

		setupContainerClick(checkbox) {
			const container = checkbox
				.closest('.ec-bundle-item')
				?.querySelector('.ec-bundle-item-content-container')
			if (container && !container.hasAttribute('data-listener-added')) {
				container.setAttribute('data-listener-added', 'true')
				container.addEventListener('click', (e) => {
					if (e.target !== checkbox && e.target.closest('select') === null) {
						checkbox.checked = !checkbox.checked
						const changeEvent = new Event('change', { bubbles: true })
						checkbox.dispatchEvent(changeEvent)
					}
				})
			}
		}

		updateRecommendations() {
			const recommendationsElement = this.querySelector('product-recommendations')
			if (!recommendationsElement) {
				return
			}

			this.initializeCheckboxes()
			this.checkAndHideIfEmpty(recommendationsElement)

			setTimeout(() => {
				const items = recommendationsElement.querySelectorAll('.ec-bundle-item')
				const itemsCount = items.length
				
				if (itemsCount === 0 && !this.hasTimedOut) {
					this.hasTimedOut = true
					this.style.opacity = '0'
					const section = this.closest('.page-width')
					if (section) {
						section.style.opacity = '0'
					}
					setTimeout(() => {
						this.style.display = 'none'
						if (section) {
							section.style.display = 'none'
						}
					}, 300)
				} else if (itemsCount > 0) {
					this.style.opacity = '1'
					const section = this.closest('.page-width')
					if (section) {
						section.style.opacity = '1'
					}
				}
			}, this.timeoutLimit)

			const observer = new MutationObserver((mutations) => {
				let shouldInitialize = false
				mutations.forEach((mutation) => {
					if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
						mutation.addedNodes.forEach((node) => {
							if (node.nodeType === 1 && (node.classList.contains('ec-bundle-item') || node.querySelector('.ec-bundle-item'))) {
								shouldInitialize = true
							}
						})
					}
				})
				if (shouldInitialize) {
					this.initializeCheckboxes()
				}
				this.checkAndHideIfEmpty(recommendationsElement)
			})

			observer.observe(recommendationsElement, { 
				childList: true, 
				subtree: true,
				attributes: true,
				attributeFilter: ['class']
			})

			setTimeout(() => {
				if (this.hasTimedOut) return
				this.checkAndHideIfEmpty(recommendationsElement)
			}, 1000)

			setTimeout(() => {
				if (this.hasTimedOut) return
				this.checkAndHideIfEmpty(recommendationsElement)
			}, 2000)
		}

		checkAndHideIfEmpty(recommendationsElement) {
			if (this.hasTimedOut) return
			
			const elapsedMs = performance.now() - this.startTime
			const items = recommendationsElement.querySelectorAll('.ec-bundle-item')
			const itemsCount = items.length
			const isLoaded = recommendationsElement.classList.contains('product-recommendations--loaded')
			const hasContent = recommendationsElement.innerHTML.trim().length > 0
			const hasInitialContent = recommendationsElement.querySelector('.ec-bundle-item') !== null
			const hasGridItems = recommendationsElement.querySelectorAll('.grid__item').length > 0
			const dataUrl = recommendationsElement.dataset.url

			if (itemsCount > 0) {
				if (!this.firstRenderTime) {
					const elapsed = ((performance.now() - this.startTime) / 1000).toFixed(2)
					this.firstRenderTime = elapsed
					this.renderTimes.push(parseFloat(elapsed))
					this.hasTimedOut = false
				}
				this.style.display = ''
				this.style.opacity = '1'
				const section = this.closest('.page-width')
				if (section) {
					section.style.display = ''
					section.style.opacity = '1'
				}
				return
			}

			if (itemsCount === 0) {
				if (elapsedMs >= this.timeoutLimit) {
					if (!this.hasTimedOut) {
						this.hasTimedOut = true
						this.style.opacity = '0'
						const section = this.closest('.page-width')
						if (section) {
							section.style.opacity = '0'
						}
						setTimeout(() => {
							this.style.display = 'none'
							if (section) {
								section.style.display = 'none'
							}
						}, 300)
					}
				} else if (isLoaded && !hasGridItems) {
					this.style.opacity = '0'
					const section = this.closest('.page-width')
					if (section) {
						section.style.opacity = '0'
					}
					setTimeout(() => {
						this.style.display = 'none'
						if (section) {
							section.style.display = 'none'
						}
					}, 300)
				} else if (hasContent && !hasInitialContent && !hasGridItems) {
					this.style.opacity = '0'
					const section = this.closest('.page-width')
					if (section) {
						section.style.opacity = '0'
					}
					setTimeout(() => {
						this.style.display = 'none'
						if (section) {
							section.style.display = 'none'
						}
					}, 300)
				}
			}
		}

		handleVariantChange(event) {
			const select = event.target
			const selectedOption = select.options[select.selectedIndex]
			const newVariantId = select.value
			const newPrice = parseInt(selectedOption.dataset.price || selectedOption.getAttribute('data-price') || '0')
			const productId = select.dataset.productId
			
			const bundleItem = select.closest('.ec-bundle-item')
			if (bundleItem) {
				const checkbox = bundleItem.querySelector('.ec-bundle-checkbox')
				const oldVariantId = checkbox ? checkbox.dataset.variantId : null
				const wasChecked = checkbox ? checkbox.checked : false
				
				bundleItem.setAttribute('data-variant-id', newVariantId)
				
				if (checkbox) {
					if (wasChecked && oldVariantId) {
						this.selectedProducts.delete(oldVariantId)
					}
					
					checkbox.dataset.variantId = newVariantId
					checkbox.dataset.price = newPrice
					
					if (wasChecked) {
						this.selectedProducts.set(newVariantId, {
							price: newPrice,
							title: checkbox.dataset.title,
							image: checkbox.dataset.image,
							variantId: newVariantId
						})
					}
				}
				
				const priceElement = bundleItem.querySelector('.ec-bundle-item-price .price-item--regular')
				if (priceElement) {
					priceElement.textContent = this.formatPrice(newPrice)
				}
				
				this.updateTotal()
			}
		}

		initializeCheckboxes() {
			const newCheckboxes = this.querySelectorAll('.ec-bundle-checkbox:not([data-listener-added])')
			newCheckboxes.forEach((checkbox) => {
				checkbox.setAttribute('data-listener-added', 'true')
				const boundHandler = this.handleCheckboxChange.bind(this)
				checkbox.addEventListener('change', boundHandler)
				this.setupContainerClick(checkbox)
			})
			this.checkboxes = this.querySelectorAll('.ec-bundle-checkbox')
		}

		handleCheckboxChange(event) {
			const checkbox = event.target
			if (!checkbox) return
			
			const variantId = checkbox.dataset.variantId || checkbox.getAttribute('data-variant-id')
			const price = parseInt(checkbox.dataset.price || checkbox.getAttribute('data-price') || '0')
			const title = checkbox.dataset.title || checkbox.getAttribute('data-title') || ''
			const image = checkbox.dataset.image || checkbox.getAttribute('data-image') || ''

			if (!variantId) {
				console.warn('ec-complementary-bundle: variantId não encontrado no checkbox')
				return
			}

			if (checkbox.checked) {
				this.selectedProducts.set(variantId, {
					price,
					title,
					image,
					variantId
				})
			} else {
				this.selectedProducts.delete(variantId)
			}

			this.updateSummary()
			this.updateTotal()
		}

		updateSummary() {
			if (!this.sectionId) return
			const totalItems = 1 + this.selectedProducts.size
			const titleElement = this.querySelector('#BundleTitle-' + this.sectionId)
			if (titleElement) {
				titleElement.textContent = `Compre os ${totalItems} itens`
			}
		}

		getPriceHTML(price) {
			if (typeof window.Shopify?.formatMoney === 'function') {
				return window.Shopify.formatMoney(price, window.money_format || '{{amount}}')
			}
			return this.formatPrice(price)
		}

		getMainProductPrice() {
			const mainPriceElement = this.querySelector('[data-main-product-price]')
			if (mainPriceElement) {
				const priceValue =
					mainPriceElement.dataset.mainProductPrice ||
					mainPriceElement.getAttribute('data-main-product-price')
				return priceValue ? parseInt(priceValue) : 0
			}
			return this.mainProductPrice || 0
		}

		updateTotal() {
			if (!this.sectionId) return
			let total = this.getMainProductPrice()

			this.selectedProducts.forEach((product) => {
				if (product && product.price) {
					total += product.price
				}
			})

			const totalElement = this.querySelector('#BundleTotal-' + this.sectionId)
			if (totalElement) {
				totalElement.innerHTML = this.getPriceHTML(total)
				totalElement.setAttribute('data-total-price', total)
			}
		}

		formatPrice(price) {
			if (typeof window.Shopify?.formatMoney === 'function') {
				return window.Shopify.formatMoney(price, window.money_format || '{{amount}}')
			}
			return new Intl.NumberFormat('pt-BR', {
				style: 'currency',
				currency: 'BRL'
			}).format(price / 100)
		}

		async handleAddToCart() {
			if (this.button.disabled) return

			this.button.disabled = true
			this.button.textContent = 'Adicionando...'

			const itemsToAdd = [{ id: this.mainVariantId, quantity: 1 }]

			this.selectedProducts.forEach((product, variantId) => {
				itemsToAdd.push({ id: variantId, quantity: 1 })
			})

			try {
				let lastResponse = null

				for (let i = 0; i < itemsToAdd.length; i++) {
					const item = itemsToAdd[i]
					const isLastItem = i === itemsToAdd.length - 1

					lastResponse = await this.addItemToCart(
						item.id,
						item.quantity,
						isLastItem && this.cart
							? {
									sections: this.cart.getSectionsToRender
										? this.cart.getSectionsToRender().map((section) => section.section || section.id).filter(Boolean)
										: [],
									sections_url: window.location.pathname
							  }
							: null
					)
				}

				if (this.cart && lastResponse) {
					if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
						publish(PUB_SUB_EVENTS.cartUpdate, {
							source: 'ec-complementary-bundle',
							cartData: lastResponse
						})
					} else {
						if (this.cart.renderContents) {
							await this.cart.renderContents(lastResponse)
						}
						if (this.cart.open && !this.cart.isClosing) {
							this.cart.open(true)
						}
					}
				} else if (!this.cart) {
					window.location.href = window.routes.cart_url
				}
			} catch (error) {
			} finally {
				if (this.button) {
					this.button.disabled = false
					this.button.textContent = this.button.dataset.originalText || 'COMPRE AGORA'
				}
			}
		}

		async addItemToCart(variantId, quantity, sectionsData = null) {
			const formData = new FormData()
			formData.append('id', variantId)
			formData.append('quantity', quantity)

			if (sectionsData) {
				if (sectionsData.sections && sectionsData.sections.length > 0) {
					formData.append('sections', sectionsData.sections.join(','))
				}
				if (sectionsData.sections_url) {
					formData.append('sections_url', sectionsData.sections_url)
				}
			}

			const config = fetchConfig('javascript')
			config.headers['X-Requested-With'] = 'XMLHttpRequest'
			delete config.headers['Content-Type']
			config.body = formData

			const response = await fetch(`${window.routes.cart_add_url}`, config)
			const data = await response.json()

			if (data.status) {
				throw new Error(data.description || 'Erro ao adicionar produto')
			}

			return data
		}
	}

	customElements.define('ec-complementary-bundle', EcComplementaryBundle)
}
